var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_vm._m(0),_c('div',[_c('Trailer_Component')],1),_c('Footer_Compontent')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"airTransport"},[_c('div',{staticClass:"airTransport_Top"},[_c('div',{staticClass:"backgroundPicture"})])])
}]

export { render, staticRenderFns }